<template>
  <b-table
    :items="items"
    :fields="headers"
    :busy="loading"
    :sort-by.sync="localSortBy"
    :sort-desc.sync="localSortDesc"
    :tbody-tr-class="rowClass"
    table-class="complaints-layout-table"
    thead-class="complaints-layout-header"
    borderless
    hover
    responsive
    show-empty
    no-local-sorting
    @row-clicked="$emit('row-clicked', $event)"
    @sort-changed="emitSortChanged"
  >
    <template #cell(companyId)="slotData">
      <span>{{ slotData.item.companyId }}</span>
    </template>

    <template #cell(company)="slotData">
      <span class="complaints-layout-muted">{{
        slotData.item.company.fantasyName
      }}</span>
    </template>

    <template #cell(protocol)="slotData">
      <strong class="complaints-layout-link">{{
        slotData.item.protocol
      }}</strong>
    </template>

    <template #cell(nature)="slotData">
      <span class="complaints-layout-muted">
        {{
          (slotData.item.nature && slotData.item.nature.value) ||
          "Não informado"
        }}
      </span>
    </template>

    <template #cell(createdAt)="slotData">
      <span class="complaints-layout-muted">{{
        slotData.item.createdAt | datetime
      }}</span>
    </template>

    <template #cell(updatedAt)="slotData">
      <span class="complaints-layout-muted">{{
        slotData.item.updatedAt | datetime
      }}</span>
    </template>

    <template #cell(status)="slotData">
      <b-badge :variant="getBadgeColor(slotData.item.status)">
        {{ getStatusText(slotData.item.status) }}
      </b-badge>
    </template>

    <template #cell(snippet)="slotData">
      <span v-html="renderSnippet(slotData.item.text, searchTerm)"></span>
    </template>

    <template #table-busy>
      <div class="text-center py-5">
        <b-spinner></b-spinner>
        <span class="ml-2">Carregando...</span>
      </div>
    </template>
    <template #empty>
      <div class="text-muted text-center py-5">
        <i class="fas fa-check-circle fa-2x"></i>
        <p class="mt-3">Nenhuma denúncia encontrada</p>
      </div>
    </template>
  </b-table>
</template>

<script>
export default {
  name: "ComplaintsTable",
  props: {
    items: { type: Array, required: true },
    headers: { type: Array, required: true },
    loading: { type: Boolean, default: false },
    sortBy: { type: String, default: null },
    sortDesc: { type: Boolean, default: false },
    searchTerm: { type: String, default: "" },
  },
  data() {
    return {
      localSortBy: this.sortBy,
      localSortDesc: this.sortDesc,
    };
  },
  watch: {
    sortBy(newVal) {
      this.localSortBy = newVal;
    },
    sortDesc(newVal) {
      this.localSortDesc = newVal;
    },
  },
  methods: {
    emitSortChanged(sortOptions) {
      this.$emit("sort-changed", sortOptions);
    },
    rowClass(item) {
      if (!item) return "";
      const baseClass =
        "complaints-layout-row complaints-layout-row--interactive";
      switch (parseInt(item.status)) {
        case 0:
          return `${baseClass} complaints-layout-row--new`;
        case 2:
          return `${baseClass} complaints-layout-row--concluded`;
        default:
          return baseClass;
      }
    },
    getStatusText(status) {
      switch (parseInt(status)) {
        case 0:
          return "Nova";
        case 1:
          return "Em processamento";
        case 2:
          return "Concluída";
        case 3:
          return "Encerrada";
        default:
          return "Indefinido";
      }
    },
    getBadgeColor(status) {
      switch (parseInt(status)) {
        case 0:
          return "primary";
        case 1:
          return "warning";
        case 2:
          return "success";
        case 3:
          return "dark";
        default:
          return "secondary";
      }
    },
    renderSnippet(text, searchTerm) {
      if (!text) return '<span class="text-muted">Sem relato</span>';
      if (!searchTerm || !searchTerm.trim()) {
        return text.length > 80 ? text.substring(0, 80) + "..." : text;
      }

      const term = searchTerm.trim().toLowerCase();

      const normalize = (str) =>
        str
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toLowerCase();

      const normalizedText = normalize(text);
      const normalizedTerm = normalize(term);

      const index = normalizedText.indexOf(normalizedTerm);
      if (index === -1) {
        return "";
      }

      const start = Math.max(0, index - 10);
      const end = Math.min(text.length, index + term.length + 10);

      let snippet = text.substring(start, end);

      if (start > 0) snippet = "..." + snippet;
      if (end < text.length) snippet = snippet + "...";

      const normalizedSnippet = normalize(snippet);
      const termIndexInSnippet = normalizedSnippet.indexOf(normalizedTerm);
      if (termIndexInSnippet !== -1) {
        const originalWord = snippet.substring(
          termIndexInSnippet,
          termIndexInSnippet + term.length
        );
        const highlighted = `<mark style="background-color: #ffeb3b; padding: 2px 4px; border-radius: 3px; font-weight: bold; color: #212529;">${originalWord}</mark>`;
        snippet =
          snippet.substring(0, termIndexInSnippet) +
          highlighted +
          snippet.substring(termIndexInSnippet + term.length);
      }

      return snippet;
    },
  },
};
</script>
